import React from 'react';
import styles from './AddressesList.module.css';
import Loading from '../Loading';

const AddressesList = ({addressSuggestions, onSelect}) => {
  return (
    <div className={styles.container}>
      {addressSuggestions.length > 0 ? (
        addressSuggestions.map((suggestion, i) => (
          <div
            className={styles.suggestionContainer}
            onClick={() => onSelect(suggestion.key)}
            key={i}>
            <p className={styles.address}>
              {suggestion.key.fullAddress} {suggestion.key.suiteName}
            </p>
          </div>
        ))
      ) : (
        <div className={styles.loadingContainer}>
          <Loading
            size={50}
            color={'var(--grey40)'}
            loading={true}
            notFullHeight={true}
            transparent
          />
        </div>
      )}
    </div>
  );
};

export default AddressesList;
